/**
 * Utilitários para manipulação de datas com suporte ao timezone de São Paulo
 */
import moment from "moment";
// const TIMEZONE = 'America/Sao_Paulo';

/**
 * Ajusta uma data UTC para o timezone de São Paulo
 */
export const ajustarDataParaSP = (dataUTC: string | null): Date | null => {
  if (!dataUTC) return null;

  try {
    const date = new Date(dataUTC);
    if (isNaN(date.getTime())) {
      console.error("Data inválida recebida:", dataUTC);
      return null;
    }
    return date;
  } catch (error) {
    console.error("Erro ao processar data:", error);
    return null;
  }
};

/**
 * Formata uma data para exibição no formato brasileiro
 * @param dataUTC Data em formato UTC
 * @param incluirHora Se true, inclui horas, minutos e segundos
 * @returns Data formatada no padrão brasileiro
 */
export const formatarData = (
  dataUTC: string | null,
  incluirHora: boolean = false
): string => {
  if (!dataUTC) {
    return "Data não disponível";
  }

  try {
    // Dividir a string para evitar interpretação de fuso horário
    const [datePart, timePart] = dataUTC.split('T');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hour, minute, second] = timePart.replace('Z', '').split(':').map(Number);

    // Criar objeto Date sem ajuste de fuso horário
    const date = new Date(year, month - 1, day, hour || 0, minute || 0, second || 0);
    if (isNaN(date.getTime())) {
      console.error("Data inválida recebida:", dataUTC);
      return "Data inválida";
    }

    // Formatar manualmente para DD/MM/YYYY HH:mm:ss
    const pad = (num: number) => String(num).padStart(2, '0');
    const result = `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;

    return result;
  } catch (error) {
    console.error("Erro ao formatar data do caixa:", error);
    return "Erro ao formatar data";
  }
};

/**
 * Formata uma data para envio à API
 * @param data Data local
 * @returns Data em formato ISO para envio à API
 */
export const formatarDataParaAPI = (data: string): string => {
  try {
    // Mantém a data exata sem ajuste de timezone
    const [ano, mes, dia] = data.split("-");
    return `${ano}-${mes}-${dia}`;
  } catch (error) {
    console.error("Erro ao formatar data para API:", error);
    throw new Error("Data inválida para envio à API");
  }
};

/**
 * Obtém a data atual no timezone de São Paulo
 * @param incluirHora Se true, inclui horas, minutos e segundos
 * @returns Data atual formatada
 */
export const getDataAtual = (incluirHora: boolean = false): string => {
  const dataAtual = new Date();
  return formatarData(dataAtual.toISOString(), incluirHora);
};

/**
 * Converte uma data local para UTC
 * @param dataLocal Data no formato local
 * @returns Data em UTC
 */
export const converterParaUTC = (dataLocal: string): string => {
  try {
    const date = new Date(dataLocal);
    return date.toISOString();
  } catch (error) {
    console.error("Erro ao converter data para UTC:", error);
    throw new Error("Data inválida para conversão");
  }
};

/**
 * Formata a data do caixa para o timezone de São Paulo
 * @param dataUTC Data em formato UTC
 * @returns Data formatada no padrão brasileiro com timezone de São Paulo
 */
export const formatarDataCaixa = (dataUTC: string | null): string => {
  if (!dataUTC) {
    return "Data não disponível";
  }

  try {
    // Dividir a string para evitar interpretação de fuso horário
    const [datePart, timePart] = dataUTC.split('T');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hour, minute, second] = timePart.replace('Z', '').split(':').map(Number);

    // Criar objeto Date sem ajuste de fuso horário
    const date = new Date(year, month - 1, day, hour, minute, second);
    if (isNaN(date.getTime())) {
      console.error("Data inválida recebida:", dataUTC);
      return "Data inválida";
    }

    // Formatar manualmente para DD/MM/YYYY HH:mm:ss
    const pad = (num: number) => String(num).padStart(2, '0');
    const result = `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;

    return result;
  } catch (error) {
    console.error("Erro ao formatar data do caixa:", error);
    return "Erro ao formatar data";
  }
};

export const formatDateToBR = (date: string) => {
  // Handle dates with time component by taking only the date part
  const datePart = date.split('T')[0];
  const [year, month, day] = datePart.split("-");
  return `${day}/${month}/${year}`;
};




